/**
 * GetSimplifyDeveloperPlansQuery — fetches paginated Simplify developer programs
 * via the ECGrid proxy endpoint.
 */

import type { IQuery, IQueryHandler, IHttpClient } from '@/application/core';
import { toCamelCase } from '@/utils/caseTransform';
import type {
  SimplifyDeveloperPlan,
  SimplifyDeveloperPlansResponse,
  SimplifyGridParams,
} from './simplify-developer-plan.types';

export class GetSimplifyDeveloperPlansQuery implements IQuery<SimplifyDeveloperPlansResponse> {
  readonly type = 'GetSimplifyDeveloperPlansQuery' as const;
  constructor(public readonly params: SimplifyGridParams) {}
}

export class GetSimplifyDeveloperPlansQueryHandler
  implements IQueryHandler<GetSimplifyDeveloperPlansQuery, SimplifyDeveloperPlansResponse>
{
  constructor(private readonly httpClient: IHttpClient) {}

  async handle(query: GetSimplifyDeveloperPlansQuery): Promise<SimplifyDeveloperPlansResponse> {
    const { page, pageSize, orders, filters } = query.params;
    const body = {
      page,
      page_size: pageSize,
      orders: orders ?? [],
      filters: filters ?? [],
    };

    const response = await this.httpClient.post<any>(
      '/api/v1/simplify-developer-plans/grid',
      body
    );

    if (response?.has_error) {
      throw new Error(response.error_message ?? 'Failed to load Simplify developer plans');
    }

    const items: SimplifyDeveloperPlan[] = (response?.items ?? []).map(
      (it: any) => toCamelCase(it) as SimplifyDeveloperPlan
    );

    return {
      items,
      totalCount: response?.total_count ?? 0,
      page: response?.page ?? page,
      pageSize: response?.page_size ?? pageSize,
    };
  }
}
